<template>
    <v-icon class="grey--text" v-if="statusCode === 2">fal fa-ban</v-icon><!--CPDS_CANCELED = 2-->
    <v-icon class="amber--text" v-else-if="statusCode === 1">fal fa-shield-check</v-icon><!--CPDS_PAID = 1-->
    <v-icon class="amber--text" v-else-if="statusCode === 3">fal fa-envelope</v-icon><!--CPDS_CONFIRMED = 3-->
    <v-icon class="blue--text" v-else-if="statusCode === 4">fal fa-box-full</v-icon><!--CPDS_PROCESSING = 4-->
    <v-icon class="blue--text" v-else-if="statusCode === 5">fal fa-box-check</v-icon><!--CPDS_PROCESSED = 5-->
    <v-icon class="amber--text" v-else-if="statusCode === 6">fal fa-hand-holding-box</v-icon><!--CPDS_PENDING = 6-->
    <v-icon class="green--text" v-else-if="statusCode === 7">fal fa-flag-checkered</v-icon><!--CPDS_DELIVERED = 7-->
    <v-icon class="error--text" v-else-if="statusCode === 8">fal fa-undo</v-icon><!--CPDS_RETURNED = 8-->
    <v-icon class="amber--text" v-else>fal fa-envelope</v-icon>
</template>

<script>
    export default {
        name: "OrdersStatus",
        props: {
            statusCode: Number
        },
    }
</script>

<style scoped>

</style>


<!--CPDS_DRAFT = -1-->
<!--CPDS_CREATED = 0-->
<!--CPDS_PAID = 1-->
<!--CPDS_CANCELED = 2-->
<!--CPDS_CONFIRMED = 3-->
<!--CPDS_PROCESSING = 4-->
<!--CPDS_PROCESSED = 5-->
<!--CPDS_PENDING = 6-->
<!--CPDS_DELIVERED = 7-->
<!--CPDS_RETURNED = 8-->
<!--customerspurchases_doc_status_choices = (-->
<!--    (CPDS_DRAFT, _(u'Rascunho')),-->
<!--    (CPDS_CREATED, _(u'Criada')),-->
<!--    (CPDS_PAID, _(u'Pagamento Confirmado')),-->
<!--    (CPDS_CANCELED, _(u'Cancelada')),-->
<!--    (CPDS_CONFIRMED, _(u'Confirmada')),-->
<!--    (CPDS_PROCESSING, _(u'Em Processamento')),-->
<!--    (CPDS_PROCESSED, _(u'Processada')),-->
<!--    (CPDS_PENDING, _(u'Pendente de Entrega')),-->
<!--    (CPDS_DELIVERED, _(u'Entregue')),-->
<!--    (CPDS_RETURNED, _(u'Devolvida'))-->
<!--)-->